// API middleware exports
import type { Context } from 'hono';

export interface AuthContext extends Context {
  user?: {
    sub: string;
    tier: 'free' | 'premium' | 'admin';
    name?: string;
  };
}

export const corsHeaders = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
  'Access-Control-Allow-Headers': 'Content-Type, Authorization'
};

export function createErrorResponse(
  status: number,
  title: string,
  detail: string,
  type: string = 'about:blank'
) {
  return {
    type,
    title,
    status,
    detail,
    instance: crypto.randomUUID()
  };
}

export function createApiResponse<T>(data: T, success = true) {
  return {
    success,
    data,
    timestamp: new Date().toISOString()
  };
}